













































































































































































































































































































































































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import DeviceApi from "@/module/device/DeviceApi";
import {Container} from "typescript-ioc";
import Device, {DregisterOptions,} from "@/model/Device";
import Pagination from '@/component/Pagination/index.vue'
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import {DbatchGenerateForm, DimportForm, DpqForm, DregisterForm} from "@/form/DeviceForm";
import ProductApi from "@/module/device/ProductApi";
import Product from "@/model/Product";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import PaginationTable from "@/component/Table/pagination-table.vue";
import MacUtil from "tools-ts/src/util/MacUtil";
import ArrayUtil from "tools-ts/src/util/ArrayUtil";
import StringUtil from "tools-ts/src/util/StringUtil";
import TaskCreate from "@/module/task/TaskCreate";
import DeviceMqttApi from "@/module/device/DeviceMqttApi";
import ConfirmDialog from "@/component/Dialog/confirm-dialog.vue";
import {DmqttPublishAllForm} from "@/form/DeviceMqttForm";
import Company from "@/model/Company";
import CompanyApi from "@/module/device/CompanyApi";
import _ from 'lodash'
import SingleDayColumn from "@/component/Table/single-day-column.vue";
import IdColumn from "@/component/Table/id-column.vue";
import BoolSelect from "@/component/Select/bool-select.vue";
import BoolColumn from "@/component/Table/bool-column.vue";
import {handleClipboard} from '@/util/clipboard';

@Component({
  components: {
    BoolColumn,
    BoolSelect,
    IdColumn,
    SingleDayColumn,
    ConfirmDialog,
    Pagination,
    DeleteDialog,
    CreateDialog,
    RefreshButton,
    PaginationTable
  },
})
export default class DeviceView extends Vue {

  private deviceApi = Container.get(DeviceApi)

  private productApi = Container.get(ProductApi)

  private dmqttApi = Container.get(DeviceMqttApi)

  private device = new Device()

  private _ = _

  private get selection() {
    // @ts-ignore
    return this.ptable?.table?.selection
  }

  @Ref()
  private ptable!: PaginationTable

  private pqForm = new DpqForm()

  private async created() {
    await this.getProducts()
    await this.getCompanies()
  }

  private mounted() {
    this.$bus.$on('device:update', () => {
      this.search()
    })
  }

  private products: Array<Product> = []

  private get cproducts(): Array<Product> {
    if (_.isEmpty(this.pqForm.companyIds))
      return this.products
    else
      return _.filter(this.products, product => {
        const company = product.company
        if (company == undefined) return false
        return this.pqForm.companyIds.includes(company.id)
      })
  }

  private async getProducts() {
    this.products = await this.productApi.list()
  }

  private async getPaging() {
    return this.deviceApi.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private search(reset = false) {
    if (reset)
      this.pqForm.currentPage = 1
    this.refresh()
  }

  @Ref()
  private registerDialog!: CreateDialog

  private registerForm = new DregisterForm()

  private registerOpts = new DregisterOptions()

  private async initRegisterOpts(proudctId: number) {
    this.registerOpts = await this.deviceApi.registerOptions(proudctId)

    if (this.registerOpts.pmacs.length > 0)
      this.registerForm.mac = this.registerOpts.pmacs[0].mac
    else this.registerForm.mac = ""

    if (this.registerOpts.pacts.length > 0)
      this.registerForm.activeCode = this.registerOpts.pacts[0].activeCode
    else this.registerForm.activeCode = ""
  }

  private async handleRegisterProductChange(proudctId: number) {
    this.initRegisterOpts(proudctId)
  }

  private async initRegisterForm() {
    this.registerForm.init()
    this.getProducts()
    if (this.products.length > 0) {
      this.registerForm.productId = this.products[0].id
      this.initRegisterOpts(this.registerForm.productId)
    }
  }

  private async registerDevice() {
    await this.deviceApi.register(this.registerForm)
  }

  @Ref()
  private deleteDialog!: DeleteDialog

  private async deleteDevice() {
    await this.deviceApi.delete(this.device.id)
  }

  @Ref()
  private importDialog!: CreateDialog

  private importForm = new DimportForm()

  private importMacs = ""

  private async initImportForm() {
    this.importForm.init()
    this.importMacs = ""
    this.products = await this.productApi.list()
    if (this.products.length > 0)
      this.importForm.productId = this.products[0].id
  }

  private async doImport() {
    this.importForm.macs = this.importMacs.split(/\r?\n/)
    const taskCreate = await this.deviceApi.import(this.importForm)
    this.handleTaskCreate(taskCreate)
  }

  @Ref()
  private batchDeleteDialog!: DeleteDialog

  private handleBatchDeleteBtnClick() {
    if (_.isEmpty(this.selection)) {
      this.$message.warning('请选择至少一个设备')
      return
    }
    this.batchDeleteDialog.open()
  }

  private async batchDelete() {
    const taskCreate = await this.deviceApi.batchDelete(
        this.selection.map((it: Device) => {
          return it.id
        })
    )
    this.handleTaskCreate(taskCreate)
  }

  @Ref()
  private genDialog!: CreateDialog

  private genForm = new DbatchGenerateForm()

  private async initGenForm() {
    this.genForm.init()
    this.products = await this.productApi.list()
    if (this.products.length > 0)
      this.genForm.productId = this.products[0].id
  }

  private async batchGenerate() {
    const taskCreate = await this.deviceApi.batchGenerate(this.genForm)
    this.handleTaskCreate(taskCreate)
  }

  @Ref()
  private publishMqttDialog!: ConfirmDialog

  private publishAllForm = new DmqttPublishAllForm()

  private async publishAllMqtt() {
    await this.dmqttApi.publishAll(this.publishAllForm)
  }

  private handleTaskCreate(taskCreate: TaskCreate) {
    if (taskCreate.isSuccess)
      this.$message.success(this.$translate("sentence.taskPublished") + taskCreate.id)
    else
      this.$message.error(this.$translate("sentence.taskPublishFailed"))
  }

  private async handleDetailClick(device: Device) {
    this.$redirector.deviceDetail({
      did: device.id.toString(),
    })
  }

  private async handleDeleteClick(device: Device) {
    this.device = device
    this.deleteDialog.open()
  }

  private activeFormatter(device: Device) {
    return this.$translate(device.active.toString())
  }

  private onlineFormatter(device: Device) {
    return this.$translate(device.online.toString())
  }

  private randomDeviceName() {
    const product = ArrayUtil.single(this.products, product => {
      return product.id == this.registerForm.productId
    })
    this.registerForm.name = product.name + StringUtil.random(6)
  }

  private randomMac() {
    this.registerForm.mac = MacUtil.random()
  }

  private companyApi = Container.get(CompanyApi)

  private companies: Array<Company> = []

  private async getCompanies() {
    this.companies = await this.companyApi.list()
  }

  private copy = handleClipboard

  private fmtAddress(address: string) {
    return _.trimStart(address, "中国")
  }
}
